var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1718 40.3828C69.2465 22.6202 58.1502 4.91754 40.3876 0.842835C22.625 -3.23187 4.92235 7.86438 0.847639 25.627C-3.22707 43.3896 7.86917 61.0923 25.6318 65.167C43.3944 69.2417 61.0971 58.1454 65.1718 40.3828Z",
    fill: "#B9C4E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9975 46.5553C40.0862 46.5553 45.8327 38.596 45.8327 28.7777C45.8327 18.9593 40.0862 11 32.9975 11C25.9089 11 20.1624 18.9593 20.1624 28.7777C20.1624 38.596 25.9089 46.5553 32.9975 46.5553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7936 45.4199C22.0526 45.4199 12.4428 47.9931 6.05835 52.0439C9.09341 56.3416 13.1126 59.8509 17.7803 62.2787C22.4481 64.7065 27.6289 65.9824 32.8903 65.9999C38.1516 66.0174 43.3408 64.7759 48.0246 62.3791C52.7083 59.9823 56.7507 56.4997 59.8142 52.2222C53.4298 48.0695 43.6977 45.4199 32.7936 45.4199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.954 32.998H31.0408C28.3336 32.998 26.139 35.1926 26.139 37.8998V49.0535C26.139 51.7606 28.3336 53.9552 31.0408 53.9552H34.954C37.6611 53.9552 39.8557 51.7606 39.8557 49.0535V37.8998C39.8557 35.1926 37.6611 32.998 34.954 32.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1903 29.7873C22.5724 32.6407 21.9406 35.1119 20.7738 35.3106C19.607 35.5093 18.3535 33.354 17.9714 30.5057C17.5892 27.6574 18.2159 25.1862 19.3828 24.9875C20.5496 24.7887 21.8031 26.9186 22.1903 29.7873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8099 29.7873C43.4226 32.6407 44.0544 35.1119 45.2213 35.3106C46.3881 35.5093 47.6416 33.354 48.0288 30.5057C48.416 27.6574 47.7791 25.1862 46.6123 24.9875C45.4455 24.7887 44.192 26.9186 43.8099 29.7873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.626 28.0803C20.1912 25.2303 19.7598 22.3837 19.3318 19.5405C19.1738 18.5214 19.0209 17.4157 19.398 16.4425C19.7751 15.4693 20.8807 14.6897 21.8641 15.0566C21.4718 13.0796 23.6628 11.6172 25.5685 10.9803C28.7577 9.81175 32.1728 9.39161 35.5502 9.75234C38.9395 10.1322 42.0843 11.701 44.4263 14.1802C45.1641 14.9561 45.7346 15.8753 46.1027 16.8807C46.76 18.8322 46.3422 20.957 45.9193 22.9951L44.9002 27.8C44.8528 28.1696 44.7106 28.5207 44.4875 28.8191C44.09 29.2624 43.4174 29.293 42.8213 29.293L23.7239 29.3388C22.5265 29.3388 20.9674 29.0433 20.8094 27.8561",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.bcfcfa33e8f8f7be89b54899364318e3.svg";
export { ForwardRef as ReactComponent };